import { jsx as _jsx } from "react/jsx-runtime";
import './map.css';
import { Box } from '@gemini/core';
import { useI18n } from '@/hooks/useI18n/useI18n';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import Router from './components/Router/Router';
import { PageLayoutContextProvider } from './hooks/usePageLayoutContext/usePageLayoutContext';
import { Custom500 } from './pages/Custom500';
export const App = () => {
    useI18n();
    return (_jsx(PageLayoutContextProvider, { children: _jsx(ErrorBoundary, { fallbackComponent: _jsx(Box, { as: "div", marginHorizontal: "1rem", marginVertical: "2.5rem", flex: 1, alignItems: "center", display: "flex", flexDirection: "column", justifyContent: "center", children: _jsx(Custom500, {}) }), children: _jsx(Router, {}) }) }));
};
